import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const isDuplicatedEmail = async (authProviderEmail) => {
  /**
   * input:
   *  authProvider: email | phone
   * output: bool
   * description: checks if email exists
   */

  try {
    const invitedAgentsRef = await collection(db, "users");
    const q = query(invitedAgentsRef, where("email", "==", authProviderEmail));
    const agentSnapshot = await getDocs(q);
    return agentSnapshot.docs.length === 0 ? true : false;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isDuplicatedEmail;
